///<reference path="../../employee/sections/employee.services.section.ts"/>

module Meevo.Plugins.Teachers {
    'use strict';

    export class ServicesSection extends Meevo.Plugins.Employee.ServicesSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherServicesOverride;
        }
    }
}